import { Box, Modal } from "@mui/material";
import { FaChevronLeft, FaRegEdit } from "react-icons/fa";
import PrescriptionPreview from "./PrescriptionPreview";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { MdOutlineLocalPrintshop } from "react-icons/md";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

const ModalPreview = ({
  open,
  setOpen,
  setIsFormView,
  formik,
  selectedDoctor,
  selectedPatient,
  isDetail,
}) => {
  const printRef = useRef();

  const [isPrint, setIsPrint] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    onAfterPrint: () => {
      setIsPrint(false);
    },
  });

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            ...style,
            width: "50%",
            overflowY: "auto",
            overflowX: "wrap",
            maxHeight: "95vh",
            padding: 0,
          }}
          className="text-left text-base"
        >
          <div className="px-8 py-2 w-full">
            <div className=" grid grid-cols-3 items-center gap-4">
              <FaChevronLeft
                className="hover:text-red-500 cursor-pointer"
                onClick={handleClose}
              />
              <p className="font-bold text-center">Prescription Preview</p>
              <div className="flex gap-2 items-center float-right text-right justify-end">
                {isDetail ? null : (
                  <button
                    className="disabled:bg-gray-300 w-[30px] h-[30px] p-[8px] flex items-center justify-center"
                    disabled={isPrint}
                  >
                    <FaRegEdit
                      className="text-blue-500 hover:text-blue-700"
                      onClick={() => setIsFormView(false)}
                    />
                  </button>
                )}
                <button
                  className="disabled:bg-gray-300 w-[30px] h-[30px] rounded-md bg-blue-500 text-white p-[8px] flex items-center justify-center hover:bg-gray-300"
                  disabled={isPrint}
                  onClick={() => {
                    setIsPrint(true);
                    handlePrint();
                  }}
                >
                  <MdOutlineLocalPrintshop className="w-full h-full" />
                </button>
              </div>
            </div>
          </div>

          <hr />
          <div className="px-8 py-2 w-full flex justify-center">
            <div className="w-full border-2 p-3 rounded-md">
              {formik.values.regular.length === 0 &&
              formik.values.concoction.length === 0 ? (
                <p>Belum ada resep</p>
              ) : (
                <PrescriptionPreview
                  formik={formik}
                  selectedDoctor={selectedDoctor}
                  selectedPatient={selectedPatient}
                />
              )}
            </div>
          </div>
        </Box>
      </Modal>

      <div className="hidden">
        <div ref={printRef}>
          {formik.values.regular.length === 0 &&
          formik.values.concoction.length === 0 ? (
            <p>Belum ada resep</p>
          ) : (
            <PrescriptionPreview
              formik={formik}
              selectedDoctor={selectedDoctor}
              selectedPatient={selectedPatient}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ModalPreview;
